import { useState } from 'react';
import { Box, Button, Dialog, IconButton, Stack, Typography } from '@material-ui/core';
import LanguageIcon from '@material-ui/icons/Language';
import { CloseOutlined } from '@material-ui/icons';
import { useLanguage } from '../contexts/language';
import Layout from './Layout';
import String from './String';

const LanguageSelector = () => {
  const { language, availableLanguages, setLanguage, content } = useLanguage();
  const [showMenu, setShowMenu] = useState(false);

  const handleClose = () => setShowMenu(false);

  return (
    <Box padding={1}>
      <IconButton
        onClick={() => setShowMenu((prev) => !prev)}
        aria-label={content('aria_open_language')}
        title={content('aria_open_language')}
      >
        <LanguageIcon color="secondary" style={{ fontSize: '1.5rem' }} />
      </IconButton>

      <Dialog open={showMenu} onClose={handleClose} aria-labelledby="language-selector-dialog-title">
        <Layout framed>
          <Stack justifyContent="center" alignItems="center" gap={1} bgcolor="transparent">
            <IconButton
              onClick={handleClose}
              aria-label={content('aria_close_language')}
              title={content('aria_close_language')}
              style={{ marginBottom: '2rem' }}
            >
              <CloseOutlined color="secondary" style={{ fontSize: '2rem' }} />
            </IconButton>

            <Typography
              id="language-selector-dialog-title"
              variant="title"
              color="secondary"
              mb={2}
              borderBottom={1}
              style={{ textTransform: 'uppercase' }}
            >
              <String s="language" />
            </Typography>

            {availableLanguages?.map((lang) => (
              <Button
                key={lang}
                my={1}
                color={language === lang ? 'primary' : 'secondary'}
                variant={language === lang ? 'contained' : 'text'}
                aria-pressed={language === lang}
                onClick={() => {
                  setLanguage(lang);
                  handleClose();
                }}
                style={{ textTransform: 'uppercase' }}
              >
                {lang}
              </Button>
            ))}
          </Stack>
        </Layout>
      </Dialog>
    </Box>
  );
};

export default LanguageSelector;
